module.exports = __webpack_public_path__ + "static/sf-partner-luxoft-b8d11b9d0df664a2705dd23603ef325e.jpg";